export default "__VITE_ASSET__9wmH033N__"